import {StateParams} from 'angular-ui-router';
import {NavigationService} from "../../Services/NavigationService";
import {ExpenseDataService} from "../../Services/ExpenseDataService";
import {EStatus, IExpenseVm, ITimeBookingVm} from "../../Data/Data";
import {NotificationService} from "../../Services/NotificationService";
import {AuthenticationService} from "../../Services/AuthenticationService";
import {getExpenseTypeLabel, getExpenseUnit} from "../../Models/expense-type-dialog";

export class ExpenseListController {
  static controllerId = "ExpenseListController";
  static $inject = [
    '$stateParams',
    NavigationService.serviceId,
    ExpenseDataService.serviceId,
    NotificationService.serviceId,
    AuthenticationService.serviceId,
  ];

  userId: number;
  expenses: IExpenseVm[] = [];
  loading = true;

  constructor($stateParams: StateParams,
              private navigation: NavigationService,
              private expenseData: ExpenseDataService,
              private notification: NotificationService,
              private authentication: AuthenticationService,) {
    this.userId = $stateParams['userId'];

    this.expenseData.browse(this.userId).then(expenses => {
      this.loading = false;
      this.expenses = expenses;
    }).catch(e => {
      if (e.httpReponse.status == 401){
        this.goBack();
        this.notification.toastError("Sie sind dazu nicht berechtigt");
        this.authentication.loadAppUser();
      }else {
        console.error(e);
        this.notification.toastError("Spesen können nicht angezeigt werden");
      }
    });
  }

  goBack() {
    this.navigation.goToMenu();
  }

  openDetail(expense: any) {
    this.navigation.goToState('expense-detail', {
      userId: this.userId,
      expenseId: expense ? expense.id : null,
    });
  }

  getStatusClass(expense: IExpenseVm) {
    if (expense.status === EStatus.Failed) {
      return 'status-red';
    } else if (expense.status === EStatus.Pending) {
      return 'status-yellow';
    } else {
      return 'status-green';
    }
  }

  getRoundedNumber(expense: IExpenseVm) {
    return expense.amount.toFixed(2);
  }

  getUnit(expense: IExpenseVm) {
    return getExpenseUnit(expense.expenseType);
  }

  getTypeLabel(expense: IExpenseVm) {
    return getExpenseTypeLabel(expense.expenseType);
  }
}
